<template>
  <svg class="inline-block -top-px relative" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path class="group-hover:stroke-red-300 transition-colors duration-200" d="M21,12a9,9,0,0,1-9,9m9-9a9,9,0,0,0-9-9m9,9H3m9,9a9,9,0,0,1-9-9m9,9c1.657,0,3-4.029,3-9s-1.343-9-3-9m0,18c-1.657,0-3-4.029-3-9s1.343-9,3-9M3,12a9,9,0,0,1,9-9" transform="translate(-2 -2)" fill="none" stroke="#191919" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>
